const shadows = {
  default: 'drop-shadow(8px 32px 32px rgba(2, 39, 44, 0.08))',
} as const;

export default shadows;

export type ThemeShadows = typeof shadows;
export type ThemeShadowsKeys = keyof typeof shadows;
